export default __webpack_public_path__ + "static/media/404_bg2.9b65855e.png";